(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmOpportunityStatus', CrmOpportunityStatus);

    CrmOpportunityStatus.$inject = ['$resource'];

    function CrmOpportunityStatus ($resource) {
        var resourceUrl =  'api/crm-opportunity-status/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
